<template>
  <div class="page">
    <div v-if="success.length > 0">
      <span class="main-title">以下楼盘已报备成功：</span>
      <div class="row" v-for="(item, idx) in success" :key="idx">
        <span class="title">{{ item.housesName }}</span>
      </div>
    </div>
    <div v-if="fail.length > 0" :class="{ 'fail-wrap': success.length > 0 }">
      <span class="main-title">以下楼盘报备失败：</span>
      <div class="row" v-for="(item, idx) in fail" :key="idx">
        <span class="title">{{ item.housesName }}</span>
        <span class="msg">{{ item.msg }}</span>
      </div>
    </div>
    <div class="btns">
      <div class="back-btn" @click.stop="goback(true)">回首页</div>
      <div class="continue-btn" @click.stop="goback(false)">继续报备</div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("qmyx");

export default {
  data() {
    return {
      success: [],
      fail: []
    };
  },
  activated() {
    const results = (this.$route.params || {}).results || [];
    this.success = results.filter(i => i.code === "0");
    this.fail = results.filter(i => i.code !== "0");
    this.reset();
  },
  methods: {
    ...mapMutations(["reset"]),
    goback(backRoot) {
      this.reset();
      if (backRoot) {
        this.$router.push({ name: "t9" });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 15px;
  color: #f07b24;
  margin-bottom: 5px;
}

.fail-wrap {
  margin-top: 39px;
}
.row {
  padding: 12px 0;
  box-shadow: 0 1px 0 0 #efefef;
  border-radius: 0.02rem;
  .title {
    font-size: 16px;
    color: #222222;
    font-weight: 500;
  }
  .msg {
    display: block;
    font-size: 14px;
    color: #666666;
    margin-top: 5px;
  }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 39px;
  .btn {
    height: 44px;
    border-radius: 8px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    &:not(:first-child) {
      margin-left: 24px;
    }
  }
  .back-btn {
    @extend .btn;

    background: #bbbbbb;
  }
  .continue-btn {
    @extend .btn;
    background: #f07b24;
  }
}
</style>
